var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.sectionData.widgets),function(widget,widgetIndex){return _c('section',{key:widgetIndex,staticClass:"container-widget"},[_c('WidgetsModulesOther',{attrs:{"widget":widget}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }